(function () {
  function moneyFormat(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      const fmt =
        (window.cartStrings && window.cartStrings.money_format) ||
        (typeof cartStrings !== "undefined" && cartStrings.money_format) ||
        "{{amount}}";
      return Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2);
  }

  function qsa(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".gogo-bundle").forEach(initBundle);
  });

  function initBundle(sectionEl) {
    const submitBtn = qs(sectionEl, "[data-submit]");
    if (!submitBtn) return;

    const min = parseInt(submitBtn.dataset.min || "0", 10);
    const max = parseInt(submitBtn.dataset.max || "0", 10);

    const msgEl = qs(sectionEl, "[data-msg]");
    const subtotalEl = qs(sectionEl, "[data-subtotal]");
    const barEl = qs(sectionEl, ".gogo-progress__bar");
    const slots = qsa(sectionEl, "[data-slot]");

    const state = { items: [] }; // [{variantId, title, img, price, qty}]

    function setMsg(t) {
      if (!msgEl) return;
      msgEl.textContent = t || "";
    }

    function totalQty() {
      return state.items.reduce(function (a, it) {
        return a + it.qty;
      }, 0);
    }

    function totalPrice() {
      return state.items.reduce(function (a, it) {
        return a + it.price * it.qty;
      }, 0);
    }

    function canAddMore() {
      if (!max || max <= 0) return true;
      return totalQty() < max;
    }

    function render() {
      const tQty = totalQty();

      // progress
      const pctRaw = min > 0 ? (tQty / min) * 100 : 100;
      const pct = Math.max(0, Math.min(100, pctRaw));
      if (barEl) barEl.style.width = pct + "%";

      // subtotal
      if (subtotalEl) subtotalEl.textContent = moneyFormat(totalPrice());

      // enable/disable submit
      const ok = tQty >= min && (!max || max <= 0 || tQty <= max);
      submitBtn.classList.toggle("is-disabled", !ok);

      // slotlar (KLON YOK): unique ürünler kadar göster
      const fills = state.items.slice(0);

      slots.forEach(function (slot, idx) {
        const imgBox = qs(slot, ".gogo-slot__img");
        const txt = qs(slot, ".gogo-slot__txt");
        const it = fills[idx];

        if (!it) {
          if (imgBox) imgBox.innerHTML = "";
          if (txt) {
            txt.innerHTML = `
              <div class="gogo-slot__line"></div>
              <div class="gogo-slot__line short"></div>
            `;
          }
          return;
        }

        if (imgBox) imgBox.innerHTML = it.img ? `<img src="${it.img}" alt="">` : "";

        if (txt) {
          txt.innerHTML = `
            <div style="font-weight:700;font-size:13px;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${it.title}</div>
            <div style="opacity:.7;font-size:12px;margin-top:2px;">${moneyFormat(it.price)}</div>
            <div class="gogo-qtyrow" style="display:flex;gap:8px;align-items:center;margin-top:6px;">
              <button type="button" data-dec="${it.variantId}" style="width:34px;height:30px;border-radius:999px;border:1px solid rgba(0,0,0,.12);background:#fff;cursor:pointer;">–</button>
              <div style="min-width:18px;text-align:center;font-weight:700;">${it.qty}</div>
              <button type="button" data-inc="${it.variantId}" style="width:34px;height:30px;border-radius:999px;border:1px solid rgba(0,0,0,.12);background:#fff;cursor:pointer;">+</button>
              <button type="button" data-del="${it.variantId}" title="Sil" style="margin-left:auto;width:34px;height:30px;border-radius:10px;border:1px solid rgba(0,0,0,.12);background:#fff;cursor:pointer;">🗑</button>
            </div>
          `;
        }
      });

      // max varsa add butonlarını kilitle
      qsa(sectionEl, "[data-add]").forEach(function (b) {
        if (!canAddMore()) b.setAttribute("disabled", "");
        else b.removeAttribute("disabled");
      });
    }

    // click handlers
    sectionEl.addEventListener("click", function (e) {
      // add product
      const addBtn = e.target.closest("[data-add]");
      if (addBtn) {
        if (!canAddMore()) return;

        const variantId = addBtn.dataset.variantId;
        const card = addBtn.closest("[data-product-card]");
        const title = (qs(card, ".gogo-card__name") && qs(card, ".gogo-card__name").textContent.trim()) || "";
        const img = (qs(card, "img") && qs(card, "img").src) || "";
        const price = parseInt((qs(card, "[data-price]") && qs(card, "[data-price]").dataset.price) || "0", 10) || 0;

        let it = state.items.find(function (x) {
          return x.variantId === variantId;
        });

        if (!it) {
          state.items.push({ variantId: variantId, title: title, img: img, price: price, qty: 1 });
        } else {
          it.qty += 1;
        }

        setMsg("");
        render();
        return;
      }

      // qty controls
      const inc = e.target.closest("[data-inc]");
      const dec = e.target.closest("[data-dec]");
      const del = e.target.closest("[data-del]");

      if (inc || dec || del) {
        const vid =
          (inc && inc.dataset.inc) ||
          (dec && dec.dataset.dec) ||
          (del && del.dataset.del);

        const it2 = state.items.find(function (x) {
          return x.variantId === vid;
        });
        if (!it2) return;

        if (inc) {
          if (!canAddMore()) return;
          it2.qty += 1;
        }
        if (dec) {
          it2.qty = Math.max(1, it2.qty - 1);
        }
        if (del) {
          state.items = state.items.filter(function (x) {
            return x.variantId !== vid;
          });
        }

        render();
        return;
      }

      // submit -> add to cart -> redirect /cart
      const submit = e.target.closest("[data-submit]");
      if (submit) {
        if (submit.classList.contains("is-disabled")) return;

        const payload = {
          items: state.items.map(function (it) {
            return { id: parseInt(it.variantId, 10), quantity: it.qty };
          }),
        };

        submit.classList.add("is-disabled");
        setMsg("Sepete ekleniyor...");

        const addUrl =
          (window.routes && window.routes.cart_add_url) ||
          (typeof routes !== "undefined" && routes.cart_add_url) ||
          "/cart/add.js";

        fetch(addUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            if (res && (res.status || res.errors)) {
              setMsg("Sepete eklenemedi.");
              render();
              return;
            }

            const cartUrl =
              (window.routes && window.routes.cart_url) ||
              (typeof routes !== "undefined" && routes.cart_url) ||
              "/cart";

            window.location.href = cartUrl;
          })
          .catch(function () {
            setMsg("Sepete eklenemedi.");
            render();
          });

        return;
      }
    });

    render();
  }
})();